import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import SuccessModal from "../../SuccessModal";
import {
  getServiceUnit,
  postBrandPackage,
  putBrandPackage,
} from "../../../services/StorePriceCode/getPriceCode";
import { getBrandAppService } from "../../../services/BrandAppServices";

const PackagePriceCreateModal = ({
  packagePriceCreateModalVisible,
  setPackagePriceCreateModalVisible,
  sendDataToPackagePriceCreateModal,
  brandId,
  selectedPackageItemValue,
  brandCarryForward,
}) => {
  const [nameValue, setNameValue] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [carryForwardValue, setCarryForwardValue] = useState("");
  const [enabledPartialAmountValue, setEnabledPartialAmountValue] =
    useState("");
  const [amountValue, setAmountValue] = useState("");
  const [quantityValue, setQuantityValue] = useState(null);
  const [defaultQuantityValue, setDefaultQuantityValue] = useState("0");
  const [appServiceValue, setAppServiceValue] = useState("");
  const [serviceUnitValue, setServiceUnitValue] = useState("");

  const [nameError, setNameError] = useState("");
  const [amountError, setAmountError] = useState("");
  const [statusError, setStatusError] = useState("");
  const [enabledPartialAmountError, setEnabledPartialAmountError] =
    useState("");
  const [quantityError, setQuantityError] = useState("");
  const [defaultQuantityError, setDefaultQuantityError] = useState("");
  const [appServiceError, setAppServiceError] = useState("");
  const [serviceUnitError, setServiceUnitError] = useState("");
  const [carryForwardValidityValue, setCarryForwardValidityValue] =
    useState("");
  const [carryForwardValidityError, setCarryForwardValidityError] =
    useState("");
    const [carryForwardValueError, setCarryForwardValueError] = useState("");

  const [modalText, setModalText] = useState("");
  const [modalStatus, setModalStatus] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [appServiceList, setAppServiceList] = useState("");
  const [serviceUnitItems, setServiceUnitItems] = useState([]);
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const statusItems = [
    {
      name: "Active",
      value: true,
    },
    {
      name: "DeActive",
      value: false,
    },
  ];

  useEffect(() => {
    getBrandAppService(brandId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          const data = res.filter((item) => item.status === true);
          const filterData = data.map((item) => ({
            name: item.appService.name,
            value: item.appService.name,
          }));
          setAppServiceList(filterData);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
    getServiceUnit()
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          const unitMapping = {
            Kg: "KG",
            SqFt: "SQ_FEET",
            Mtr: "METER",
            Qty: "QUANTITY",
          };

          const filterData = res.map((item) => ({
            name: unitMapping[item] || item,
            value: item,
          }));
          setServiceUnitItems(filterData);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }, []);

  useEffect(() => {
    if (selectedPackageItemValue !== null) {
      setNameValue(selectedPackageItemValue?.name || "");
      setAmountValue(selectedPackageItemValue?.amount.toString() || "");
      setAppServiceValue(selectedPackageItemValue?.appService || "");
      setQuantityValue(selectedPackageItemValue?.quantity.toString() || "");
      setDefaultQuantityValue(selectedPackageItemValue?.defaultQuantity.toString() || "");
      setServiceUnitValue(selectedPackageItemValue?.serviceUnit || "");
      setStatusValue(selectedPackageItemValue?.status || false);
      setCarryForwardValue(selectedPackageItemValue?.carryForward || false);
      setCarryForwardValidityValue(
        selectedPackageItemValue?.validity?.toString() || ""
      );
      setEnabledPartialAmountValue(
        selectedPackageItemValue?.enabledPartialAmount || false
      );
    }
  }, [selectedPackageItemValue]);

  const handleConfirmPickup = () => {
    // Reset all previous errors

    setNameError("");
    setAmountError("");
    setAppServiceError("");
    setQuantityError("");
    setDefaultQuantityError("");
    setServiceUnitError("");
    setStatusError("");
    setEnabledPartialAmountError("");
    setCarryForwardValidityError("");
    setCarryForwardValueError("")

    let isValid = true;
    if (!nameValue) {
      setNameError("Name is required");
      isValid = false;
    }
    if (!amountValue) {
      setAmountError("Amount is required");
      isValid = false;
    }
    if (!appServiceValue) {
      setAppServiceError("App Service is required");
      isValid = false;
    }
    if (!quantityValue) {
      setQuantityError("Quantity is required");
      isValid = false;
    }
    if (serviceUnitValue !== "Qty" && !defaultQuantityValue && quantityValue > 1) {
      setDefaultQuantityError("Default Quantity is required");
      isValid = false;
    }
    if (!serviceUnitValue) {
      setServiceUnitError("Service Unit is required");
      isValid = false;
    }

    if (brandCarryForward && carryForwardValue === "") {
      setCarryForwardValueError("Carry Forward selection is required");
      isValid = false;
    }
    
    if (brandCarryForward && carryForwardValue === true && !carryForwardValidityValue) {
      setCarryForwardValidityError("Please Enter Validity");
      isValid = false;
    }

    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        if (selectedPackageItemValue === null) {
          const price = {
            brandId: brandId,
            priceCode: nameValue,
            description: nameValue,
            priceType: "PACKAGE",
            status: true,
          };
          const data = {
            price: price,
            brandId: brandId,
            name: nameValue,
            description: nameValue,
            amount: amountValue,
            appService: appServiceValue,
            quantity: quantityValue,
            defaultQuantity: defaultQuantityValue,
            serviceUnit: serviceUnitValue,
            status: true,
            enabledPartialAmount: carryForwardValue ? false : true,
            carryForward: carryForwardValue,
            validity: carryForwardValue ? carryForwardValidityValue : 0,
          };
          postBrandPackage(brandId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }

                  setNameValue("");
                  setStatusValue("");
                  setAmountValue("");
                  setAppServiceValue("");
                  setQuantityValue("");
                  setDefaultQuantityValue("");
                  setServiceUnitValue("");
                  setCarryForwardValue("");
                  setEnabledPartialAmountValue("");
                  setCarryForwardValidityValue(0);

                  setNameError("");
                  setAmountError("");
                  setAppServiceError("");
                  setQuantityError("");
                  setDefaultQuantityError("");
                  setServiceUnitError("");
                  setStatusError("");
                  setEnabledPartialAmountError("");
                  setCarryForwardValidityError("");
                    setCarryForwardValueError("")

                  setIsSubmitButtonPressed(false);
                  sendDataToPackagePriceCreateModal({
                    success: true,
                  });
                  setPackagePriceCreateModalVisible(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          const updateData = {
            ...selectedPackageItemValue,
            price: {
              ...selectedPackageItemValue.price,
              brandId: brandId,
              priceCode: nameValue,
              description: nameValue,
              priceType: "PACKAGE",
              status: statusValue,
            },
            brandId: brandId,
            name: nameValue,
            description: nameValue,
            amount: amountValue,
            appService: appServiceValue,
            quantity: quantityValue,
            defaultQuantity: defaultQuantityValue,
            serviceUnit: serviceUnitValue,
            status: statusValue,
            enabledPartialAmount: carryForwardValue
              ? false
              : enabledPartialAmountValue,
            carryForward: carryForwardValue,
            validity: carryForwardValue ? carryForwardValidityValue : 0,
          };
          putBrandPackage(brandId, updateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }

                  setNameValue("");
                  setStatusValue("");
                  setAmountValue("");
                  setAppServiceValue("");
                  setQuantityValue("");
                  setDefaultQuantityValue("");
                  setServiceUnitValue("");
                  setCarryForwardValue("");
                  setEnabledPartialAmountValue("");
                  setCarryForwardValidityValue(0);

                  setNameError("");
                  setAmountError("");
                  setAppServiceError("");
                  setQuantityError("");
                  setDefaultQuantityError("");
                  setServiceUnitError("");
                  setStatusError("");
                  setEnabledPartialAmountError("");
                  setCarryForwardValidityError("");
                    setCarryForwardValueError("");

                  setIsSubmitButtonPressed(false);
                  sendDataToPackagePriceCreateModal({
                    success: true,
                  });
                  setPackagePriceCreateModalVisible(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    }
  };

  const handleModalClose = () => {
    setNameValue("");
    setStatusValue("");
    setAmountValue("");
    setAppServiceValue("");
    setQuantityValue("");
    setDefaultQuantityValue("");
    setCarryForwardValue("");
    setServiceUnitValue("");
    setEnabledPartialAmountValue("");
    setCarryForwardValidityValue(0);

    setNameError("");
    setAmountError("");
    setAppServiceError("");
    setQuantityError("");
    setDefaultQuantityError("");
    setServiceUnitError("");
    setStatusError("");
    setEnabledPartialAmountError("");
    setCarryForwardValidityError("");
    setCarryForwardValueError("")
    setIsSubmitButtonPressed(false);
    setPackagePriceCreateModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        visible={packagePriceCreateModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!packagePriceCreateModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-2 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Package {selectedPackageItemValue === null ? "Create" : "Edit"}
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>

            <div
              className="h-25rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4 mt-4">
                <FloatLabel>
                  <InputText
                    id="nameValue"
                    value={nameValue}
                    onChange={(e) => setNameValue(e.target.value)}
                    className="w-full text-xl p-2 border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                    placeholder="Name"
                  />
                  <label
                    htmlFor="nameValue"
                    className="text-md"
                    style={{ color: "blue" }}
                  >
                    Name <span style={{ color: "red" }}>*</span>
                  </label>
                  {nameError && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {nameError}
                    </p>
                  )}
                </FloatLabel>
              </div>

              <div className="mx-4 mt-4">
                <FloatLabel>
                  <InputText
                    id="amountValue"
                    value={amountValue}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        setAmountValue(value);
                      }
                    }}
                    className="w-full text-xl p-2 border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                    placeholder="Amount"
                  />
                  <label
                    htmlFor="amountValue"
                    className="text-md"
                    style={{ color: "blue" }}
                  >
                    Amount <span style={{ color: "red" }}>*</span>
                  </label>
                  {amountError && (
                    <p className="text-lg font-normal" style={{ color: "red" }}>
                      {amountError}
                    </p>
                  )}
                </FloatLabel>
              </div>

              <div>
                <div className="mx-4 mt-4  ">
                  <FloatLabel>
                    <Dropdown
                      id="appServiceValue"
                      value={appServiceValue}
                      onChange={(e) => setAppServiceValue(e.value)}
                      options={appServiceList}
                      optionLabel="name"
                      placeholder="App Service"
                      className="w-full border-round-xl  text-2xl text-xl shadow-2"
                    />
                    {appServiceError && (
                      <p
                        className="text-lg font-normal"
                        style={{ color: "red" }}
                      >
                        {appServiceError}
                      </p>
                    )}
                    <label
                      htmlFor="appServiceValue"
                      className="text-md"
                      style={{ color: "blue" }}
                    >
                      App Service
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </FloatLabel>
                </div>

                <div className="mx-4 mt-4  ">
                  <FloatLabel>
                    <Dropdown
                      id="serviceUnitValue"
                      value={serviceUnitValue}
                      onChange={(e) => setServiceUnitValue(e.value)}
                      options={serviceUnitItems}
                      optionLabel="name"
                      placeholder="Service Unit"
                      className="w-full border-round-xl  text-2xl text-xl shadow-2"
                    />
                    {serviceUnitError && (
                      <p
                        className="text-lg font-normal"
                        style={{ color: "red" }}
                      >
                        {serviceUnitError}
                      </p>
                    )}
                    <label
                      htmlFor="serviceUnitValue"
                      className="text-md"
                      style={{ color: "blue" }}
                    >
                      Service Unit
                      <span style={{ color: "red" }}>*</span>
                    </label>
                  </FloatLabel>
                </div>

                <div className="mx-4 mt-4">
                  <FloatLabel>
                    <InputText
                      id="quantityValue"
                      value={quantityValue}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setQuantityValue(value);
                        }
                      }}
                      className="w-full text-xl p-2 border-round-xl shadow-2"
                      style={{
                        backgroundColor: "#fff",
                      }}
                      placeholder="Quantity"
                    />
                    <label
                      htmlFor="quantityValue"
                      className="text-md"
                      style={{ color: "blue" }}
                    >
                      Quantity <span style={{ color: "red" }}>*</span>
                    </label>
                    {quantityError && (
                      <p
                        className="text-lg font-normal"
                        style={{ color: "red" }}
                      >
                        {quantityError}
                      </p>
                    )}
                  </FloatLabel>
                </div>

                {serviceUnitValue !== "Qty" && quantityValue > 1 &&
                  <div className="mx-4 mt-4">
                  <FloatLabel>
                    <InputText
                      id="defaultQuantityValue"
                      value={defaultQuantityValue}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          if (Number(value) < Number(quantityValue)) {
                            setDefaultQuantityValue(value);
                            setDefaultQuantityError("")
                          } else {
                            setDefaultQuantityError("Please enter value less than quantity")
                          }
                        }
                      }}
                      className="w-full text-xl p-2 border-round-xl shadow-2"
                      style={{
                        backgroundColor: "#fff",
                      }}
                      placeholder="Default Quantity"
                    />
                    <label
                      htmlFor="defaultQuantityValue"
                      className="text-md"
                      style={{ color: "blue" }}
                    >
                      Default Quantity <span style={{ color: "red" }}>*</span>
                    </label>
                    {defaultQuantityError && (
                      <p
                        className="text-lg font-normal"
                        style={{ color: "red" }}
                      >
                        {defaultQuantityError}
                      </p>
                    )}
                  </FloatLabel>
                </div>}


                
              </div>

              <div>
                {serviceUnitValue !== "Qty" &&
                  selectedPackageItemValue !== null &&
                  carryForwardValue === false && (
                    <div className="mx-4 mt-4  ">
                      <FloatLabel>
                        <Dropdown
                          id="enabledPartialAmountValue"
                          value={enabledPartialAmountValue}
                          onChange={(e) =>
                            setEnabledPartialAmountValue(e.value)
                          }
                          options={statusItems}
                          optionLabel="name"
                          placeholder="Enabled Partial Amount"
                          className="w-full border-round-xl  text-2xl text-xl shadow-2"
                        />
                        {enabledPartialAmountError && (
                          <p
                            className="text-lg font-normal"
                            style={{ color: "red" }}
                          >
                            {enabledPartialAmountError}
                          </p>
                        )}
                        <label
                          htmlFor="enabledPartialAmountValue"
                          className="text-md"
                          style={{ color: "blue" }}
                        >
                          Enabled Partial Amount
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </FloatLabel>
                    </div>
                  )}

                {brandCarryForward && (
                  <div>
                    <div className="mx-4 mt-4 mb-2 ">
                      <FloatLabel>
                        <Dropdown
                          id="carryForwardValue"
                          value={carryForwardValue}
                          onChange={(e) => setCarryForwardValue(e.value)}
                          options={statusItems}
                          optionLabel="name"
                          placeholder="Carry Forward"
                          className="w-full border-round-xl  text-2xl text-xl shadow-2"
                        />
                        <label
                          htmlFor="carryForwardValue"
                          className="text-md"
                          style={{ color: "blue" }}
                        >
                          Carry Forward
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        {carryForwardValueError && (
                            <p
                              className="text-lg font-normal"
                              style={{ color: "red" }}
                            >
                              {carryForwardValueError}
                            </p>
                          )}
                      </FloatLabel>
                    </div>

                    {carryForwardValue === true && (
                      <div className="mx-4 mt-4 mb-2">
                        <FloatLabel>
                          <InputText
                            id="carryForwardValidityValue"
                            value={carryForwardValidityValue}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                setCarryForwardValidityValue(value);
                              }
                            }}
                            className="w-full text-xl p-2 border-round-xl shadow-2"
                            style={{
                              backgroundColor: "#fff",
                            }}
                            placeholder="carryForwardValidityValue"
                          />
                          <label
                            htmlFor="carryForwardValidityValue"
                            className="text-md"
                            style={{ color: "blue" }}
                          >
                            Carry Forward Validity In Days{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          {carryForwardValidityError && (
                            <p
                              className="text-lg font-normal"
                              style={{ color: "red" }}
                            >
                              {carryForwardValidityError}
                            </p>
                          )}
                        </FloatLabel>
                      </div>
                    )}
                  </div>
                )}

                {selectedPackageItemValue !== null && (
                  <div className="mx-4 mt-4  ">
                    <FloatLabel>
                      <Dropdown
                        id="statusValue"
                        value={statusValue}
                        onChange={(e) => setStatusValue(e.value)}
                        options={statusItems}
                        optionLabel="name"
                        placeholder="Status"
                        className="w-full border-round-xl  text-2xl text-xl shadow-2"
                      />
                      {enabledPartialAmountError && (
                        <p
                          className="text-lg font-normal"
                          style={{ color: "red" }}
                        >
                          {enabledPartialAmountError}
                        </p>
                      )}
                      <label
                        htmlFor="statusValue"
                        className="text-md"
                        style={{ color: "blue" }}
                      >
                        Status
                        <span style={{ color: "red" }}>*</span>
                      </label>
                    </FloatLabel>
                  </div>
                )}
              </div>
            </div>

            <Button
              className="mt-1 mb-3 mx-4 border-round-xl "
              onClick={handleConfirmPickup}
              disabled={isSubmitButtonPressed}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default PackagePriceCreateModal;
